let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b50Uh")).then(() => parcelRequire('bgk2M'));